import request from '@/utils/request'
import { MenuCodeReq, MenuCodeRes } from '@/services/menuCode/menuCode.types'

export const getMenuCode = (params: MenuCodeReq) => request.get<MenuCodeRes, MenuCodeReq>('/api/v1/menus', params)
